import React, { useState,useEffect } from 'react'
import { Link } from "react-scroll"
import logo from '../asset/img/icono.jpg'
const Navbar = ({ navbar, setNavbar }) => {
  const [responsiveness, setResponsiveness] = useState(false);
  const [showData, setShow] = useState(false);
  const changeBackground = () => {
    if (window.scrollY >= 534) {

      setNavbar(true);
    } else {
      setNavbar(false);
    }
  }

  const handleClick = () => {
    window['scrollTo']({ top: 0, behavior: 'smooth' });
  };

  const GitHub = () => {
    window.open("https://github.com/RafaDev-IT", "_blank")
  }

  const whatsapp = () => {
    window.open("https://api.whatsapp.com/send?phone=50375511863&text=Hola%20Rafa%20me%20gustó%20tu%20portafolio%20", "_blank")
  }

  const linkedin = () => {
    window.open("https://www.linkedin.com/in/rafael-martinez-00384a205/", "_blank")
  }

  window.addEventListener('scroll', changeBackground);


  const handleToggleMenu = () => {
    const $menu = document.querySelector('#navbarSupportedContent');
    const $textoMenu = document.querySelector('#textoMenu');
    const $show = document.querySelector('.show');
    if ($show) {
      $textoMenu.innerHTML = `<i class="fas fa-hamburger mr-1"  aria-hidden="true"></i>MENU`
      $menu.classList.remove('show');
    }

  }
    useEffect(() => {
      
      const responsivenessLogo2 = () =>
        window.innerWidth > 990 ? setShow(false) : setShow(true);
        responsivenessLogo2();
      window.addEventListener("resize", () => responsivenessLogo2());

      const responsivenessLogo = () =>
        window.innerWidth < 420 ? setResponsiveness(true) : setResponsiveness(false);
      responsivenessLogo();
      window.addEventListener("resize", () => responsivenessLogo());
  }, []);
 

  const handleCerrar = (e) => {
    const $show = document.querySelector('.show');
    const $textoMenu = document.querySelector('#textoMenu')
    const $menu = document.querySelector('#navbarSupportedContent');
    const $btn = document.querySelector('#navigationMenu');



    if (e.target.classList.contains('textoMenu')) {
      if ($show) {
        $textoMenu.innerHTML = `<i style={{color:'white'}} class="fas fa-hamburger mr-1"  aria-hidden="true"></i>MENU`
      } else {
        $textoMenu.innerHTML = `<i class="fas fa-times mr-1"  aria-hidden="true"></i>CERRAR`
      }
    }

    if (e.target.classList.contains('fa-hamburger')) {
      if ($show) {
        $textoMenu.innerHTML = `<i class="fas fa-hamburger mr-1"  aria-hidden="true"></i>MENU`
      } else {
        $menu.classList.add('show');
        $textoMenu.innerHTML = `<i class="fas fa-times mr-1"  aria-hidden="true"></i>CERRAR`
      }
    }

    if (e.target.classList.contains('fa-times')) {
      $textoMenu.innerHTML = `<i class="fas fa-hamburger mr-1"  aria-hidden="true"></i>MENU`
      $menu.classList.remove('show');
      $btn.ariaExpanded = false;
    }

    if (e.target.classList.contains('collapsed') || e.target.classList.contains('navbar-toggler')) {

      if ($textoMenu.textContent === "MENU") {
        $textoMenu.innerHTML = `<i class="fas fa-times mr-1"  aria-hidden="true"></i>CERRAR`
      } else {
        $textoMenu.innerHTML = `<i class="fas fa-hamburger mr-1"  aria-hidden="true"></i>MENU`
      }
    }

    
  }
  return (
    <header className="header-wraper" id="home">
      <nav className={navbar ? 'navbar navbar-expand-lg navbar-dark ftco_navbar ftco-navbar-light site-navbar-target navbar-fixed-top fixed-top activate' : 'navbar navbar-expand-lg navbar-dark ftco_navbar ftco-navbar-light site-navbar-target navbar-fixed-top'}>
        <div className="container mt-2">
          <img src={logo} width='90px' alt="Logo" style={{ borderRadius: 50}}/> <span style={{ marginLeft: '12px',color: '#fff', fontSize: '22px', fontFamily: 'Cabin, sans-serif !important' }} className="mr-5">Rafael Martinez</span>
          {responsiveness ? (<button style={{display:'flex', justifyContent: 'center', margin:'auto'}} onClick={handleCerrar} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" id="navigationMenu">
            <span className="textoMenu" id='textoMenu'><i className="fas fa-hamburger mr-1" ></i>MENU</span>
          </button>) : (showData ? (<button style={{display:'flex', justifyContent: 'center', margin:'auto'}} onClick={handleCerrar} className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" id="navigationMenu">
            <span className="textoMenu" id='textoMenu'><i className="fas fa-hamburger mr-1" ></i>MENU</span></button>):'')
          }
          
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <Link smooth={true} to="home" offset={-100} className="nav-link" onClick={handleToggleMenu} >Inicio</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="about" offset={-100} className="nav-link" onClick={handleToggleMenu}>Sobre mí</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="services" offset={-80} className="nav-link" onClick={handleToggleMenu}>Servicios</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="skill" offset={-145} className="nav-link" onClick={handleToggleMenu}>Habilidades</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="experiencie" offset={-100} className="nav-link" onClick={handleToggleMenu}>Logros</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="méritos" offset={-100} className="nav-link" onClick={handleToggleMenu}>Méritos</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="portafolio" offset={-100} className="nav-link" onClick={handleToggleMenu}>Portafolio</Link>
              </li>
              <li className="nav-item">
                <Link smooth={true} to="contact" offset={-100} className="nav-link" onClick={handleToggleMenu}>Contacto</Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
      <button className={navbar ? 'btn btn-primary scollButtons linkedin iconos' : 'ocultar'} onClick={linkedin} style={{ marginBottom: navbar ? '225px' : '0' }}>
      <center><i class="fab fa-linkedin" aria-hidden="true"></i></center>
      </button>

      <button className={navbar ? 'btn btn-primary scollButtons whatsapp iconos' : 'ocultar'} onClick={whatsapp} style={{ marginBottom: navbar ? '150px' : '0' }}>
        <i className="fab fa-whatsapp" aria-hidden="true"></i>
      </button>

      <button className={navbar ? 'btn btn-dark scollButtons mt-5 iconos' : 'ocultar'} onClick={GitHub} style={{ marginBottom: navbar ? '70px' : '0' }}>
        <i className="fab fa-github" style={{ fontSize: '35px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}></i>
      </button>


      <button className={navbar ? 'btn btn-primary scollButtons mt-5 iconos' : 'ocultar'} onClick={handleClick}>
        <i className="fa fa-angle-up" aria-hidden="true"></i>
      </button>


    </header>
  );
}

export default Navbar;